import { RotateCcw } from "lucide-react";
import { ARENA_LABEL, ARENA_COLS } from "./arenaData";

// Pick exactly 6 of the available stats for the fixed columns. The Player and Form
// columns are permanent. When 6 are selected, the rest are disabled (swap one out first).
export function ColumnsMenu({ hidden, toggle, reset }) {
  const visibleCount = ARENA_COLS.filter((s) => !hidden.includes(s)).length;
  const atMax = visibleCount >= 6;
  return (
    <div className="la-menu" data-testid="arena-columns-menu" role="menu">
      <div className="la-menu-title">Στατιστικά · {visibleCount}/6</div>
      <div className="la-menu-hint" data-testid="arena-columns-hint">Διάλεξε 6 στατιστικά. Η φόρμα δείχνει πάντα.</div>
      <label className="la-menu-item is-locked"><input type="checkbox" checked disabled aria-label="Player (always visible)" />Παίκτης</label>
      {ARENA_COLS.map((k) => {
        const checked = !hidden.includes(k);
        const disabled = !checked && atMax;
        return (
          <label key={k} className={`la-menu-item ${disabled ? "is-disabled" : ""}`}>
            <input type="checkbox" checked={checked} disabled={disabled} onChange={() => toggle(k)} data-testid={`arena-col-toggle-${k}`} />
            {ARENA_LABEL[k]}
          </label>
        );
      })}
      <label className="la-menu-item is-locked"><input type="checkbox" checked disabled aria-label="Form (always visible)" />Φόρμα</label>
      <button type="button" className="la-menu-reset" onClick={reset} data-testid="arena-columns-reset"><RotateCcw size={13} /> Επαναφορά</button>
    </div>
  );
}
